import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Row, Col } from 'react-bootstrap'

import { getOAuthURL } from 'src/actions/authorization.actions'

const GoogleOAuth = () => {
  const dispatch = useDispatch()

  const url = useSelector(state => state.authorization.oauthUrl)

  useEffect(() => {
    dispatch(getOAuthURL())
  }, [])

  return (
    <div className={'mt-3'}>
      <Row>
        <Col xl={12}>
          <a href={url} target={'_blank'} rel="noreferrer">
            Autenticarse con google
          </a>
        </Col>
        <Col xl={12}>
          <hr />
        </Col>
      </Row>
    </div>
  )
}
export default GoogleOAuth
